import { NumberInputProps, SelectProps, TextareaProps, TextInputProps } from "@mantine/core";
import { InputSelectProps } from "./InputSelect";
import InputSelect from "./InputSelect";
import Input from "../Input";
import { ReactNode } from "react";
import { IMaskInput } from "react-imask";
import { NumberInput } from "../Input/NumberInput";

interface MaskInputProps {
  component?: ReactNode | typeof IMaskInput;
  mask?: string;
  onAccept?: (value: string) => void;
}

interface InputWithSelectProps {
  selectProps: InputSelectProps & SelectProps & { side?: "left" | "right" };
  inputProps?: MaskInputProps & TextInputProps & TextareaProps & { pii?: boolean };
  inputNumberProps?: NumberInputProps & { pii?: boolean };
  isNumberInput?: boolean;
}

const InputWithSelect = ({ selectProps, inputProps, isNumberInput = false, inputNumberProps }: InputWithSelectProps) => {
  const { side = "right" } = selectProps;
  const section = side === "left" ? "leftSection" : "rightSection";
  const sectionProps = {
    [section]: <InputSelect {...selectProps} />,
    [`${section}Width`]: selectProps.width,
  };
  return isNumberInput ? (
    <NumberInput {...inputNumberProps} {...sectionProps} isSectionDropdown />
  ) : (
    <Input {...inputProps} {...sectionProps} isSectionDropdown />
  );
};

export default InputWithSelect;
